import { render } from "./Theme.vue?vue&type=template&id=20150212&scoped=true"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import "./Theme.vue?vue&type=style&index=0&id=20150212&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-20150212"

export default script